import React, { ReactElement } from "react";
import HubCategory from "../../../components/Hubs/Categories";
import Layout from "../../../components/layout";

const HubCategoryPage = (): ReactElement => {
  return (
    <Layout>
      <HubCategory />
    </Layout>
  );
};

export default HubCategoryPage;
